import {
  useSessionStorageManualPaginatedResource,
  type SessionStorageFiltersConfig,
} from "../../../shared/hooks/useSessionStorageManualPaginatedResource";
import { useGetNewsReportPreview } from "../services/newService";

type NewsPreviewFilters = {
  lifeguard_name: string;
  building_id: string;
  report_type_id: string;
  start_date: string;
  end_date: string;
};

const NEWS_PREVIEW_FILTER_CONFIG: SessionStorageFiltersConfig<NewsPreviewFilters> =
  {
    defaultFilters: {
      lifeguard_name: "",
      building_id: "",
      report_type_id: "",
      start_date: "",
      end_date: "",
    },
    filterKeys: [
      "lifeguard_name",
      "building_id",
      "report_type_id",
      "start_date",
      "end_date",
    ],
    tabStorageId: "novedades",
  };

export const useNewsReportPreviewResource = () => {
  const {
    page,
    pageSize,
    draftFilters,
    appliedFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    applyFilters,
    resetFilters,
  } = useSessionStorageManualPaginatedResource(NEWS_PREVIEW_FILTER_CONFIG);

  const {
    data: newsReportData,
    isLoading,
    isError,
    isFetching,
    refetch,
  } = useGetNewsReportPreview({
    page,
    page_size: pageSize,
    lifeguard_name: appliedFilters.lifeguard_name || undefined,
    building_id: appliedFilters.building_id || undefined,
    report_type_id: appliedFilters.report_type_id
      ? Number(appliedFilters.report_type_id)
      : undefined,
    start_date: appliedFilters.start_date || undefined,
    end_date: appliedFilters.end_date || undefined,
  });

  return {
    data: newsReportData,
    isLoading,
    isError,
    isFetching,
    page,
    pageSize,
    filters: draftFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    applyFilters,
    resetFilters,
    refetch,
  };
};
